const s = {
  name: "Membercard",
  dimensions: { width: 40, height: 26 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 26" style="enable-background:new 0 0 40 26;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M16,8H5V6h11V8z"/>
		<path class="st0" d="M5,12h11v-2H5V12z"/>
		<path class="st0" d="M16,16H5v-2h11V16z"/>
		<path class="st0" d="M5,20h11v-2H5V20z"/>
		<path class="st0" d="M24,17c0-1.7,1.3-3,3-3h5c1.7,0,3,1.3,3,3v3h-2v-3c0-0.5-0.5-1-1-1h-5c-0.5,0-1,0.5-1,1v3h-2V17z"/>
		<path class="st0" d="M29.5,6C27.6,6,26,7.6,26,9.5s1.6,3.5,3.5,3.5S33,11.4,33,9.5S31.4,6,29.5,6z M28,9.5C28,8.7,28.7,8,29.5,8
			C30.3,8,31,8.7,31,9.5c0,0.8-0.7,1.5-1.5,1.5C28.7,11,28,10.3,28,9.5z"/>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v20c0,1.7,1.3,3,3,3h34c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H3z M2,3c0-0.6,0.4-1,1-1h16
			v22H3c-0.6,0-1-0.4-1-1V3z M21,24V2h16c0.6,0,1,0.4,1,1v20c0,0.6-0.4,1-1,1H21z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Membercard
};
